import _ from 'underscore'

export function map(source, target) {
  _.extend(target, source)
}
